// Bottom navigation per tablet/mobile
import { NavLink, useLocation } from 'react-router-dom'
import { LayoutDashboard, Ticket, FileText, Package, Settings } from 'lucide-react'
import { cn } from '../../lib/utils'

const MOBILE_NAV = [
  { to: '/', label: 'Dashboard', icon: <LayoutDashboard className="h-5 w-5" /> },
  { to: '/tickets', label: 'Ticket', icon: <Ticket className="h-5 w-5" /> },
  { to: '/reports', label: 'Report', icon: <FileText className="h-5 w-5" /> },
  { to: '/warehouse', label: 'Magazzino', icon: <Package className="h-5 w-5" /> },
  { to: '/settings', label: 'Altro', icon: <Settings className="h-5 w-5" /> },
]

export function MobileBottomNav() {
  const location = useLocation()

  const isActive = (to: string) => {
    if (to === '/') return location.pathname === '/'
    return location.pathname.startsWith(to)
  }

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 flex border-t border-[var(--fc-border)] bg-[var(--fc-surface)] md:hidden"
      aria-label="Navigazione mobile"
    >
      {MOBILE_NAV.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/'}
          className={cn(
            'flex flex-1 flex-col items-center justify-center gap-1 py-2 text-xs font-medium transition-colors',
            isActive(item.to)
              ? 'text-[var(--fc-primary)]'
              : 'text-[var(--fc-foreground-muted)] hover:text-[var(--fc-foreground)]'
          )}
          aria-current={isActive(item.to) ? 'page' : undefined}
        >
          {item.icon}
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
